module.exports = __webpack_public_path__ + "static/media/LifestyleMentors.1fa2c7b3.png";